<div class="container px-5 py-16 pb-8 pt-4 mx-auto">

 

  <div
    class="grid   justify-stretch      xs:grid-cols-1 sm:grid-cols-1 md2:grid-cols-1 md:grid-cols-1  lg2:grid-cols-2 lg:grid-cols-2  xl2:grid-cols-2 xl:grid-cols-3  2xl:grid-cols-4 ">

    @for (item of filteredItems; track $index) {
      <app-prod-card [item]="item" [isSS]="isSS" class="w-full flex"></app-prod-card>


    }




  </div>



</div>

